// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"8cc5519d","32":"5607f394","92":"5461e421","364":"447d455a","524":"674202ec","847":"d98e0e16","982":"31d6cfe0"}[chunkId] + ".chunk.css";
};